import * as Sentry from "@sentry/react";

export const initSentry = () => {
  const envMode = import.meta.env.MODE;

  if (envMode === "development" || import.meta.env.VITE_MODE_APP === "dev") {
    return;
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.warn("Sentry DSN not defined. Skipping Sentry init.");
    return;
  }

  Sentry.init({
    dsn,
    environment: envMode,
    tracesSampleRate: 0.2,
    release: import.meta.env.VITE_APP_VERSION,
  });

  console.log(`Sentry initialized for [${envMode}] environment`, dsn);
};
